export const SNACKBAR_AUTO_HIDE_DURATION = 3500;
